import { gql } from "@apollo/client";

const GET_CLIENT = gql`
  query client($clientIdentifier: String!) {
    client(clientIdentifier: $clientIdentifier) {
      id
      identifier
      name
      riskScore {
        current {
          id
          riskScoreClass
          totalScore
        }
        currentManualRiskScore {
          id
        }
      }
      settings {
        accounting {
          accountingSystem
          autobookActive
        }
        product {
          defaultInvoiceServiceType
        }
      }
      invoiceReaderTemplates {
        id
        name
        state
      }
      emailConnections {
        id
        clientIdentifier
        emailAddress
        modifiedAt
      }
    }
  }
`;

export default GET_CLIENT;
